//consent forms
export class ConsentFinancialSettings{
    data: Data;
    message: string;
    statusCode: number;
}

export class Data{
  acces_Token: any;
    iS_PATIENT_CONSENT_AGREE:any;
    iS_PATIENT_FINANCIAL_AGREE:any;
    financial_Form: any;
    patient_Consent_Form: any;
    patient_Consent_Form_Path: any;
    financial_Form_Path: any;
    practice_Code: any;
    practice_Message: any;
    is_Consent_Agree: any;
    is_Financial_Agree: any;
    iS_FINANCIAL_CONSENT_TOALL: any;
    iS_PATIENT_CONSENT_TOALL: any;
    iS_ALLOW_NEW_PATIENT: any;
    iS_ALLOW_EXISTING_PATIENT_WITHOUT_APPOINTMENT: any;
    enable_Symston_Checker: any;
    sick_Visit: any;
    followUp_Visit: any;
    annual_Visit: any;
    enable_Intake_form: any;
    checkIn_Message_Description: any;
    enable_Psychiatric_Symptom: any;
    isEnableROSSymptom: any;
    enable_Pediatrics_Form: any;
  enable_COVID19_Questionnaire: any;

}
